
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { units } from "./unit-data";

interface MeasurementTypeSelectProps {
  value: string;
  onValueChange: (value: string) => void;
}

export function MeasurementTypeSelect({ value, onValueChange }: MeasurementTypeSelectProps) {
  return (
    <div>
      <label className="text-sm font-medium text-manuscript-primary mb-2 block">
        Select Measurement Type
      </label>
      <Select value={value} onValueChange={onValueChange}>
        <SelectTrigger className="w-full h-12 md:h-10 text-base md:text-sm">
          <SelectValue placeholder="Choose type" />
        </SelectTrigger>
        <SelectContent className="z-50">
          {Object.keys(units).map((type) => (
            <SelectItem key={type} value={type} className="text-base md:text-sm py-3 md:py-1.5">
              {type.charAt(0).toUpperCase() + type.slice(1)}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
